<template>
  <div class="map">
    <StaticMap />
  </div>
</template>

<script>
// @ is an alias to /src
import StaticMap from "@/components/StaticMap.vue";

export default {
  name: "Map",
  components: {
    StaticMap
  }
};
</script>
